import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock, ArrowRight } from "lucide-react";
import { SITE } from "@/data/site";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="tw-section relative overflow-hidden"
    >
      <div
        className="glow-blob"
        style={{
          top: "10%",
          right: "-15%",
          width: 620,
          height: 620,
          background: "radial-gradient(circle, #1fa8ff 0%, transparent 60%)",
          opacity: 0.45,
        }}
      />
      <div
        className="glow-blob"
        style={{
          bottom: "-10%",
          left: "-10%",
          width: 500,
          height: 500,
          background: "radial-gradient(circle, #0b6cc9 0%, transparent 60%)",
          opacity: 0.35,
        }}
      />

      <div className="relative z-10 tw-container grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
          >
            <div className="overline">06 — Kontakt</div>
            <h2 className="mt-4 md:mt-6 tw-heading-section">
              Dogovorimo
              <br />
              <span className="blue-text font-display italic">saradnju.</span>
            </h2>
            <p className="mt-8 max-w-lg text-[#c8d6ec] text-base md:text-lg leading-relaxed">
              Javite nam tip objekta, procenu količine tekstila i dinamiku rada.
              U roku od jednog radnog dana pripremamo personalizovanu ponudu,
              predlog termina preuzimanja i plan saradnje prilagođen vašem timu.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
              <a
                href={SITE.phoneHref}
                data-testid="contact-cta-button"
                className="tw-btn w-full sm:w-auto justify-center"
              >
                Pozovite nas <ArrowRight size={16} strokeWidth={2.5} />
              </a>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="contact-email-link"
                className="tw-btn-ghost w-full sm:w-auto justify-center"
              >
                Zatražite ponudu
              </a>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-5">
          <div className="tw-card p-5 sm:p-7 md:p-10">
            <div className="overline mb-8">Informacije</div>
            <ContactRow
              icon={Phone}
              label="Telefon"
              value={SITE.phone}
              href={SITE.phoneHref}
              testid="contact-phone"
            />
            <ContactRow
              icon={Mail}
              label="Email"
              value={SITE.email}
              href={`mailto:${SITE.email}`}
              testid="contact-email-row"
            />
            <ContactRow
              icon={MapPin}
              label="Adresa"
              value={`${SITE.address.street}, ${SITE.address.postalCode} ${SITE.address.city}`}
              testid="contact-address"
            />
            <ContactRow
              icon={Clock}
              label="Radno vreme"
              value={SITE.hours}
              testid="contact-hours"
              last
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactRow({ icon: Icon, label, value, href, testid, last }) {
  const Comp = href ? "a" : "div";
  return (
    <Comp
      href={href}
      data-testid={testid}
      className={`group flex items-start gap-4 py-5 ${last ? "" : "border-b border-[#55d0ff]/12"}`}
    >
      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#55d0ff]/25 to-[#0b6cc9]/20 border border-[#55d0ff]/30 flex items-center justify-center shrink-0">
        <Icon size={18} strokeWidth={1.8} className="text-[#a7e2ff]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="overline text-[10px] text-[#8ea6c8]">{label}</div>
        <div className="mt-1 font-heading-md text-sm sm:text-base md:text-lg text-white group-hover:text-[#55d0ff] transition-colors duration-500 break-words">
          {value}
        </div>
      </div>
    </Comp>
  );
}
